import { ActionPopUpSingleButton, deserify } from '@geneo2-web/shared-ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLiveQuizContext } from '../../../app/Context/LiveQuizContextProvider';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { HOME } from '../../../routeHandling/RoutesNomenclature';

export const LiveQuizStalePopup = () => {
  const navigate = useNavigate();
  const {
    sessionInstanceInvalid,
    resetLiveQuizData,
    hasSessionInstance,
    flagSessionStale,
    detachLiveQuizTab,
  } = useLiveQuizContext();
  const { live_quiz_session } = deserify(
    useAppSelector((state) => state.liveQuiz)
  );

  // redux-persist (localStorage) is shared across tabs, but the instance id
  // (sessionStorage) is per tab. A tab that opens straight onto Lobby/Play
  // with a persisted session but no id of its own was never in control.
  useEffect(() => {
    if (live_quiz_session && !hasSessionInstance()) flagSessionStale();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOk = () => {
    navigate(HOME, { replace: true });
    detachLiveQuizTab(); // not resetLiveQuizData()
  };

  return (
    <ActionPopUpSingleButton
      open={sessionInstanceInvalid}
      fontSmall={true}
      iconName="wifi"
      popupText="Session Stale"
      splitText="This live quiz is now being controlled from another tab or window."
      buttontext="Go to Home"
      textcolor="primary"
      ctaHandler={handleOk}
      // no handleClose: the popup can't be dismissed by clicking the backdrop
    />
  );
};
